export const storyMarquee = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(".p-top-story-slider");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const inners = slider.querySelectorAll<HTMLElement>(".p-top-story-slider__inner");
    if (!inners.length) return;

    const firstInner = inners[0];
    const innerWidth = firstInner.offsetWidth;
    if (!innerWidth) return;

    // PC 幅では 30s, SP 幅では 20s で一周する速度にする
    // SCSS のブレークポイント sm(700px) に合わせて判定
    const isPcWidth = window.innerWidth >= 700;
    const durationSec = isPcWidth ? 30 : 20;
    const speedPxPerSec = innerWidth / durationSec;

    let lastTime = performance.now();
    let scroll = 0;

    const step = (time: number) => {
      const dt = (time - lastTime) / 1000;
      lastTime = time;

      scroll += speedPxPerSec * dt;
      const offset = scroll % innerWidth;

      // 2本の __inner は元のレイアウト位置（x 座標）が異なるので、
      // 同じ offset だけ translate すれば「同じ距離だけ動く」マルキーになる
      inners.forEach((inner) => {
        inner.style.transform = `translate3d(${-offset}px, 0, 0)`;
      });

      requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  });
};

